import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from "@material-ui/core/Grid";
import { CheckActionPermission } from "Actions/commonAction";
import Button from "@material-ui/core/Button";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import emptylist from "../../../../../../../Assets/Svg/signingauth.svg";

class Policy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // const [permissions] = CheckActionPermission("exitPolicy");
    const [isTrue, permissions] = CheckActionPermission("signatory");
    if (isTrue) {
      this.setState({ permissions });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  render() {
    return (
      <div>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <Grid container className="height100">
            <Grid item xs={12} md={12} sm={12}>
              <div className="display-table height100 width100">
                <div className="display-table-cell vertical-middle">
                  <div className="text-center">
                    <img src={emptylist} width="25%"></img>
                  </div>
                  <div className="page-subheader-name text-center t-bold">
                    Add your first signing authority
                  </div>
                  {this.state.permissions && this.state.permissions.editable && (
                    <div className="text-center">
                      <Button
                        color="primary"
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        onClick={this.props.onCreateAuthority}
                      >
                        Create
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

Policy.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles()(withSnackbar(Policy))),
);
